
<ng-container [ngSwitch]="themeClass">
  <ng-container *ngSwitchCase="'woch'">
    <span class="week-day">{{ date | date:"EEEE":'':'de' }}</span><span style="text-transform: none">, den</span>
    <span class="month-day">{{ date | date:"d":'':'de' }}.</span>
    <span class="month">{{ date | date:"MMMM":'':'de' }}</span>
    <span class="year">{{ date | date:"y":'':'de' }}</span>
  </ng-container>
  <ng-container *ngSwitchCase="'week'">
    <span class="week-day">{{ date | date:"EEEE":'':'en' }},</span>
    <span class="month">{{ date | date:"MMMM":'':'en' }}</span>
    <span class="month-day">{{ date | date:"d":'':'en' }}<sup>{{ getOrdinalNum(date.getDate()) }}</sup>,</span>
    <span class="year">{{ date | date:"y":'':'en' }}</span>
  </ng-container>
  <ng-container *ngSwitchCase="'mlwk'">
    <span class="week-day">{{ date | date:"EEEE":'':'en' }},</span>
    <span class="month">{{ date | date:"MMMM":'':'en' }}</span>
    <span class="month-day">{{ date | date:"d":'':'en' }}<sup>{{ getOrdinalNum(date.getDate()) }}</sup>,</span>
    <span class="year">{{ date | date:"y":'':'en' }}</span>
  </ng-container>
  <ng-container *ngSwitchCase="'mwne'">
    <span class="week-day">{{ date | date:"EEEE":'':'en' }},</span>
    <span class="month">{{ date | date:"MMMM":'':'en' }}</span>
    <span class="month-day">{{ date | date:"d":'':'en' }}<sup>{{ getOrdinalNum(date.getDate()) }}</sup>,</span>
    <span class="year">{{ date | date:"y":'':'en' }}</span>
  </ng-container>
  <ng-container *ngSwitchCase="'mlne'">
    <span class="week-day">{{ date | date:"EEEE":'':'en' }},</span>
    <span class="month">{{ date | date:"MMMM":'':'en' }}</span>
    <span class="month-day">{{ date | date:"d":'':'en' }}<sup>{{ getOrdinalNum(date.getDate()) }}</sup>,</span>
    <span class="year">{{ date | date:"y":'':'en' }}</span>
  </ng-container>
  <ng-container *ngSwitchCase="'sema'">
    <span class="week-day">{{ date | date:"EEEE":'':'es' }},</span>
    <span class="month-day">{{ date | date:"d":'':'es' }} de </span>
    <span class="month" style="text-transform: capitalize">{{ date | date:"MMMM":'':'es' }}</span>
    <span class="year"> de {{ date | date:"y":'':'es' }}</span>
  </ng-container>
  <ng-container *ngSwitchCase="'mwde'">
    <span class="week-day">{{ date | date:"EEEE":'':'en' }},</span>
    <span class="month">{{ date | date:"MMMM":'':'en' }}</span>
    <span class="month-day">{{ date | date:"d":'':'en' }}<sup>{{ getOrdinalNum(date.getDate()) }}</sup>,</span>
    <span class="year">{{ date | date:"y":'':'en' }}</span>
  </ng-container>
  <ng-container *ngSwitchCase="'mwjp'">
    <span class="week-day">{{ date | date:"EEEE":'':'en' }},</span>
    <span class="month">{{ date | date:"MMMM":'':'en' }}</span>
    <span class="month-day">{{ date | date:"d":'':'en' }}<sup>{{ getOrdinalNum(date.getDate()) }}</sup>,</span>
    <span class="year">{{ date | date:"y":'':'en' }}</span>
  </ng-container>
  <ng-container *ngSwitchCase="'clfy'">
    <span class="week-day">{{ date | date:"EEEE":'':'en' }},</span>
    <span class="month">{{ date | date:"MMMM":'':'en' }}</span>
    <span class="month-day">{{ date | date:"d":'':'en' }}<sup>{{ getOrdinalNum(date.getDate()) }}</sup>,</span>
    <span class="year">{{ date | date:"y":'':'en' }}</span>
  </ng-container>
  <ng-container *ngSwitchCase="'mljp'">
    <span class="week-day">{{ date | date:"EEEE":'':'en' }},</span>
    <span class="month">{{ date | date:"MMMM":'':'en' }}</span>
    <span class="month-day">{{ date | date:"d":'':'en' }}<sup>{{ getOrdinalNum(date.getDate()) }}</sup>,</span>
    <span class="year">{{ date | date:"y":'':'en' }}</span>
  </ng-container>
  <ng-container *ngSwitchCase="'mlde'">
    <span class="week-day">{{ date | date:"EEEE":'':'en' }},</span>
    <span class="month">{{ date | date:"MMMM":'':'en' }}</span>
    <span class="month-day">{{ date | date:"d":'':'en' }}<sup>{{ getOrdinalNum(date.getDate()) }}</sup>,</span>
    <span class="year">{{ date | date:"y":'':'en' }}</span>
  </ng-container>
  <ng-container *ngSwitchDefault>
    <span class="week-day">{{ date | date:"EEEE"}}</span>
    <span class="month-day">{{ date | date:"d"}}</span>
    <span class="month">{{ date | date:"MMMM"}}</span>
    <span class="year">{{ date | date:"y"}}</span>
  </ng-container>
</ng-container>
